import { render, staticRenderFns } from "./gaiKuang.vue?vue&type=template&id=cb32475e&scoped=true&"
import script from "./gaiKuang.vue?vue&type=script&lang=js&"
export * from "./gaiKuang.vue?vue&type=script&lang=js&"
import style0 from "./gaiKuang.vue?vue&type=style&index=0&id=cb32475e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb32475e",
  null
  
)

export default component.exports